import type { ITopicsSDK } from '@1js/cortex-topics-bootstrapper';
import { tryGetTopicsSdk as realTryGetTopicsSdk } from 'owa-topic-annotations';
import getTopicsSdkAsync from './getTopicsSdkAsync';

/**
 * Returns the Topics SDK if it's been initialized.
 * If it hasn't been initialized, it will trigger the initialization.
 */
export function tryGetTopicsSdk(): ITopicsSDK | undefined {
    const topicsSdk = realTryGetTopicsSdk();
    if (!topicsSdk) {
        getTopicsSdkAsync().catch(error => {
            /* no-op */
        });
    }
    return topicsSdk;
}
